export enum AccordionId {
    ImportantInformation = "lets_get_started_button",
    YourDetails = "agreeButton",
    PensionOptions = "your_pention_options_save_button",
    AboutYou = "about_you_save_button",
    DailyActivities = "your_daily_activities_save_button",
    DependantAboutYou = "about_your_spouse_save_button",
    DependantDailyActivities = "their_daily_activities_save_button",
    Finally = "last_agree_button",
}

export enum AccordionStatus {
    Incomplete = "incomplete",
    Success = "success",
    Error = "error",
}

export enum PensionWiseBooking {
    BookForMe = "bookForMe",
    AlreadyHadOne = "alreadyHad",
    BookMyOwn = "bookMyOwn",
    AlreadyHadAdvice = "advised",
    AlreadyHaveAppointment = "notHadYet",
    ProceedWithout = "without",
}
